
/*
  主要工具模块
 */
// 引入vueX状态管理库
import store from '../store'


/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 密码
 * @param {*} s
 */
export function isPwd (s) {
  return /^(\w){6,20}$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}


// 验证是否整数,非必填
export function isIntegerNotMust(rule, value, callback) {
  if (!value) {
    callback();
  }
  setTimeout(() => {
    if (!Number(value)) {
      callback(new Error('请输入正整数'));
    } else {
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
  }, 1000);
}




// 自定义密码校验
export function validateNewPass(rule, value, callback) {
  let passwordRule = '',promptText = '';
  switch (store.state.user.getAccountPolicy.passwordComplexity) {
    case '1':
      passwordRule = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{6,})$/
      promptText = '必须同时包含数字、英文字母'
      break;
    case '2':
      passwordRule = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[\(\)~!@#$%\^&\*_\-\+\=\|\{\}\[\]:;<>,\.\?/  ])[a-zA-Z0-9\(\)~!@#$%\^&\*_\-\+\=\|\{\}\[\]:;<>,\.\?/ ]+$/
      promptText = '必须同时包含数字、英文字母和特殊符号()~!@#$%^&*_-+=|{}[]:;'
      break;
    case '3':
      passwordRule = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[ \(\)~!@#$%\^&\*_\-\+\=\|\{\}\[\]:;<>,\.\?/])(?!.*\s).{8,}$/
      promptText = '必须同时包含数字、大写和小写字母以及特殊符号()~!@#$%^&*_-+=|{}[]:;'
      break;
  }
  if (value === "") {
    return callback(new Error("请输入密码"));
  }
  // 可增加密码自定义规则
  if ((value ? value.length : 0 ) < Number(store.state.user.getAccountPolicy.passwordLength) ) {
    return callback(new Error('至少' + store.state.user.getAccountPolicy.passwordLength + '个字符,'+ promptText));
  }
  if ((value ? value.length : 0 ) > 15 ) {
    return callback(new Error("密码长度最大不能超过" + 15 + '个字符'));
  }
  // 可增加密码自定义规则
  if (passwordRule.test(value) !== true ) {
    return callback(new Error(promptText));
  }
  callback();
}


